import { normalizeGet } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getClipboard = normalizeGet(function (args) {
  return swan.getClipboardData(args);
}, CONTAINER_NAME.BAIDU);
export default getClipboard;